import { render, staticRenderFns } from "./OrderPropertyList.vue?vue&type=template&id=fe8a0bd2&"
import script from "./OrderPropertyList.vue?vue&type=script&lang=js&"
export * from "./OrderPropertyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe8a0bd2')) {
      api.createRecord('fe8a0bd2', component.options)
    } else {
      api.reload('fe8a0bd2', component.options)
    }
    module.hot.accept("./OrderPropertyList.vue?vue&type=template&id=fe8a0bd2&", function () {
      api.rerender('fe8a0bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/OrderPropertyList.vue"
export default component.exports